import type { IPermissionRepository } from '@src/domain/rbac/repository/permission_repository';
import type { Permission } from '@src/domain/rbac/entities/permission.entity';
import type { UpdatePermissionData } from '@src/domain/rbac/value_objects/update_permission_data';

/**
 * Update Permission Use Case
 * Updates a permission (only description can be updated)
 */
export class UpdatePermissionUseCase {
    constructor(private readonly permissionRepository: IPermissionRepository) { }

    async execute(permissionId: string, data: UpdatePermissionData): Promise<Permission> {
        return await this.permissionRepository.update(permissionId, data);
    }
}
